module.exports = __webpack_public_path__ + "static/media/policeCar_orange.410a3e0c.svg";